import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

export const DragIconReplacement = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "drag-icon-replacement",
})`
  width: 24px;
  height: 20px;
`;

export const StatusIconReplacement = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "status-icon-replacement",
})`
  width: 24px;
  height: 20px;
`;
